export const FIND_ASSIGNABLE_ADDON_ROUTINES = `
  query FindAssignableRoutinesForAddon($filter: FindAssignableAddonRoutinesFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    addon {
      findAssignableRoutinesForAddon(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name inAssignments }
      }
    }
  }
`;
